import { createStore, createEffect } from "effector"
import User from "models/User"
import UserService from "services/UserService"
import i18n from "intl/i18n"
import { updateLocale } from "utils/moment"
import { initFiltersStoreUser } from "./filters"
import viewSettings from "./viewSettings"
import CustomError from "models/CustomError"
import { ErrorCode } from "config/constants"

// Stores
const $user = createStore<User | null>(null)

// Effects
const fetchUser = createEffect(async () => {
    const user = await UserService.getCurrentUser()
    if (user) {
        initFiltersStoreUser(user)
        viewSettings.initViewSettingsStoreUser(user)
    }
    if (user?.language) {
        i18n.changeLanguage(user.language)
        await updateLocale(user.language)
    }
    return user
})

const changeLanguage = createEffect(async (language: string) => {
    if (!language) return
    const linkUpdateUser = $user.getState()?.linkUpdate
    if (!linkUpdateUser) {
        throw new CustomError({
            code: ErrorCode.systemError,
        })
    }

    try {
        await UserService.setLanguage(linkUpdateUser, language)
        i18n.changeLanguage(language)
        await updateLocale(language)
        return language
    } catch(e) {
        throw new CustomError({
            code: ErrorCode.systemError,
        })
    }
})

// Listeners
$user.on(fetchUser.doneData, (_, payload) => payload)
$user.on(changeLanguage.doneData, (state, language) => {
    if (!state || !language) return state
    state.language = language
    return state
})

// Exports
export default {
    $user,
    changeLanguage,
    fetchUser,
}
